import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import Spinner from '@atlaskit/spinner';
import { MenuButtonItem } from '@atlassian/navigation-system/side-nav/menu-button-item';

import { messages } from './messages';

type MenuLoadingItemProps = {
	icon: ReactNode;
	label: ReactNode;
};
export const MenuLoadingItem = ({ icon, label }: MenuLoadingItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<MenuButtonItem
			elemBefore={icon}
			elemAfter={<Spinner size="small" />}
			testId="menu-button-loading"
		>
			{label}
			<span aria-label={formatMessage(messages.loadingItemAriaLabel)} />
		</MenuButtonItem>
	);
};
